import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HomeProject } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { HttpResponse } from '@angular/common/http';

export interface PostProjectParams extends DefaultHttpHeaders {}

@Injectable()
export class PostProjectService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Generates insurance project
   * Generates insurance project
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Project/postProject
   */
  postProject(body: HomeProject, params: PostProjectParams): Observable<HomeProject> {
    return this.post<HomeProject, HomeProject>({
      suffix: `/home/project`,
      body,
      authenticationType: 'jwt',
    });
  }
}
